import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from './base.service';
import { Observable } from 'rxjs';
import { ConversationMessage } from '../models/conversation-message';

@Injectable({
  providedIn: 'root'
})
export class SessionsService extends BaseApiService {

  constructor(http: HttpClient) {
    super(http, 'sessions');
  }

  getConversation(userSessionId: string): Observable<ConversationMessage[]> {
    return this._http.get<ConversationMessage[]>(`${this._baseUrl}/${userSessionId}/conversation`);
  }
}
